export default __webpack_public_path__ + "static/media/fMaltoBuza8.920e5785.png";